import { Link } from 'react-router-dom';
import { AlertTriangle, X, KeyRound } from 'lucide-react';
import { useAiKeyStatus } from '../store/aiKeyStatus';

const HEADLINE = {
  AI_KEY_INVALID: 'AI provider key rejected',
  AI_QUOTA_EXCEEDED: 'AI provider quota exhausted',
  AI_ALL_PROVIDERS_FAILED: 'Every configured AI provider failed',
  NO_AI_PROVIDER: 'No AI provider configured',
};

const BODY = {
  AI_KEY_INVALID:
    'Your saved AI key was rejected by the provider. Update or remove it in Account settings.',
  AI_QUOTA_EXCEEDED:
    'Your AI provider account has no remaining quota. Top up the account or switch to a different key.',
  AI_ALL_PROVIDERS_FAILED:
    'Both of your configured AI providers failed. Check both keys in Account settings.',
  NO_AI_PROVIDER:
    'Add an Anthropic or OpenAI key in Account settings to enable AI features.',
};

export default function AiKeyErrorBanner() {
  const lastError = useAiKeyStatus((s) => s.lastError);
  const clear = useAiKeyStatus((s) => s.clear);
  if (!lastError) return null;

  const headline = HEADLINE[lastError.code] || 'AI provider error';
  const body = BODY[lastError.code] || lastError.message || '';
  const providerLabel =
    lastError.provider === 'anthropic'
      ? ' (Anthropic)'
      : lastError.provider === 'openai'
        ? ' (OpenAI)'
        : '';

  return (
    <div className="rounded-lg border border-amber-200 bg-amber-50/70 px-3 py-2 flex items-center gap-3 mb-4 text-sm">
      <AlertTriangle className="w-4 h-4 flex-none text-amber-600" />
      <div className="flex-1 min-w-0 flex items-baseline gap-2 flex-wrap">
        <span className="font-medium text-amber-900">
          {headline}
          {providerLabel}
        </span>
        <span className="text-xs text-amber-800/70 truncate">{body}</span>
      </div>
      <Link
        to="/account"
        className="flex-none text-xs font-medium text-amber-900 hover:text-amber-700 inline-flex items-center gap-1"
      >
        <KeyRound className="w-3 h-3" /> Fix it →
      </Link>
      <button
        type="button"
        onClick={clear}
        className="flex-none text-amber-700 hover:text-amber-900 p-0.5 rounded transition-colors"
        aria-label="Dismiss"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
}
